/**
 * Normalize station from a /weld-status weld row into a plain display string.
 * Matches Device Overview style: "2" or joined distinct stations "1, 2" — not "Station 2".
 */
export function normalizeWeldStationNumber(weld) {
  if (!weld || typeof weld !== 'object') return undefined;

  const raw =
    weld.station_number ?? weld.stationNumber ?? weld.Station;

  if (raw == null || raw === '') return undefined;

  const value = String(raw).trim();
  if (!value || value === '-') return undefined;

  return value;
}

/** First numeric station token for sorting (supports "1, 2"). */
export function firstStationSortKey(stationValue) {
  if (stationValue == null || stationValue === '') return NaN;
  const first = String(stationValue).split(',')[0].trim();
  const n = Number(first);
  return Number.isFinite(n) ? n : NaN;
}
